import { IonItem, IonLabel, IonList } from '@ionic/react';
import { ReactElement, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton } from './action-button';
import { ButtonProps } from './base-button';

export interface SaveActionsProps {
  hasExistingSave?: boolean;
  onSave?: () => void;
  onSaveAs?: () => void;
  buttonProps?: ButtonProps;
  labels?: {
    actionButton?: string;
    save?: string;
    saveAs?: string;
  };
}

export const SaveActions = (props: SaveActionsProps): ReactElement => {
  const {
    hasExistingSave = false,
    onSave,
    onSaveAs,
    buttonProps,
    labels = {},
  } = props;
  const { i18n } = useTranslation();

  const defaultLabels = useMemo(
    () => ({
      actionButton: i18n.t('common:save'),
      save: i18n.t('common:save'),
      saveAs: i18n.t('common:save_as'),
    }),
    [i18n]
  );

  const finalLabels = useMemo(
    () => ({ ...defaultLabels, ...labels }),
    [defaultLabels, labels]
  );

  const handleAction = useCallback(
    (action: () => void | undefined, close: () => void) => {
      if (action) {
        action();
      }
      close();
    },
    []
  );

  const renderActionList = useCallback(
    ({ close }: { close: () => void }) => (
      <IonList>
        {hasExistingSave && onSave && (
          <IonItem
            button
            detail={false}
            onClick={() => handleAction(onSave, close)}
          >
            <IonLabel>{finalLabels.save}</IonLabel>
          </IonItem>
        )}
        {onSaveAs && (
          <IonItem
            button
            detail={false}
            onClick={() => handleAction(onSaveAs, close)}
          >
            <IonLabel>{finalLabels.saveAs}</IonLabel>
          </IonItem>
        )}
      </IonList>
    ),
    [hasExistingSave, onSave, onSaveAs, finalLabels, handleAction]
  );

  return (
    <ActionButton label={finalLabels.actionButton} buttonProps={buttonProps}>
      {renderActionList}
    </ActionButton>
  );
};
